/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Contract_TestsInputs */

const en_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract tests`)
};

const ar_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختبارات العقود`)
};

const bn_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কন্ট্রাক্ট টেস্ট`)
};

const de_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertragstests`)
};

const es_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruebas de contrato`)
};

const fr_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essais contractuels`)
};

const pt_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testes de contrato`)
};

const zh_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合同测试`)
};

const tr_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sözleşme testleri`)
};

const ru_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контрактные тесты`)
};

const pl_svchip_contract_tests = /** @type {(inputs: Svchip_Contract_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testy kontraktowe`)
};

/**
* | output |
* | --- |
* | "Contract tests" |
*
* @param {Svchip_Contract_TestsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_contract_tests = /** @type {((inputs?: Svchip_Contract_TestsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Contract_TestsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_contract_tests(inputs)
	if (locale === "bn") return bn_svchip_contract_tests(inputs)
	if (locale === "de") return de_svchip_contract_tests(inputs)
	if (locale === "es") return es_svchip_contract_tests(inputs)
	if (locale === "fr") return fr_svchip_contract_tests(inputs)
	if (locale === "pt") return pt_svchip_contract_tests(inputs)
	if (locale === "zh") return zh_svchip_contract_tests(inputs)
	if (locale === "tr") return tr_svchip_contract_tests(inputs)
	if (locale === "ru") return ru_svchip_contract_tests(inputs)
	if (locale === "pl") return pl_svchip_contract_tests(inputs)
	return en_svchip_contract_tests(inputs)
});